import React, { useEffect, useState } from "react";
import { Card, Form, Row, Container, Col, Button } from "react-bootstrap";
import { GlobalState } from "contexts/GlobalState";

import "./style.scss";

const PSYCHO_MAX = 800;
const PSYCHO_MIN = 200;
const MATURITY_MAX = 117;
const MATURITY_MIN = 55;

export const ProfileEdit = ({labels,onClick}) => {
  const [globalUser,setGlobalUser] = GlobalState("user");
  const [profile, setProfile] = useState({
    id: globalUser.user.id,
    psychometric: globalUser.user.psychometric,
    maturity: globalUser.user.maturity,
    adapter: globalUser.user.adapter,
  });
  const [validated, setValidated] = useState(false);
  const maturityInvalid = (profile.maturity < MATURITY_MIN || profile.maturity > MATURITY_MAX) && validated;
  const psychoInvalid = (profile.psychometric < PSYCHO_MIN || profile.psychometric > PSYCHO_MAX) && validated

  useEffect(() => { 
    document.getElementsByName("psychometric")[0].focus();
  },[]);

  const handleChange = (field, target) => {
    if (target.value)
      setProfile((prevState) => ({ ...prevState, [field]: target.value }));
  };

  const validate = () => {
    if (profile.psychometric > PSYCHO_MAX || profile.psychometric < PSYCHO_MIN) {
      document.getElementsByName("psychometric")[0].focus();
      return false;
    } 
    if (profile.maturity < MATURITY_MIN || profile.maturity > MATURITY_MAX) {
      document.getElementsByName("maturity")[0].focus();
      return false;
    }
    return true;
  }

  const saveProfile = (e, name) => {
    e.preventDefault();
    setValidated(true);
    if (validate() === true) {
      onClick(name,profile.psychometric,profile.maturity);
    }

  };  

  return (
    <div className="profile-edit">
      <div className="label-2">{labels.label_2}</div>
      <Form>
        <Form.Group controlId="formPsychometric">
          <Form.Control
            size="sm"
            type="number"
            name="psychometric"
            className={psychoInvalid ? "is-invalid" : ""}
            placeholder={labels.psychometric}
            aria-label={labels.psychometric}
            aria-invalid={psychoInvalid}
            aria-describedby={psychoInvalid ? labels.psychometricError : ""}
            onChange={(e) => handleChange("psychometric", e.target)}
          />
        </Form.Group>
        <Form.Group controlId="formMaturity">
          <Form.Control
            size="sm"
            type="number"
            name="maturity"
            className={maturityInvalid ? "is-invalid" : ""}
            placeholder={labels.maturity}
            aria-label={labels.maturity}
            aria-invalid={maturityInvalid}
            aria-describedby={maturityInvalid ? labels.maturityError : ""}
            onChange={(e) => handleChange("maturity", e.target)}
          />
        </Form.Group>
        <Button
          ari-label={labels.btn_save}
          variant="primary"
          onClick={(e) => saveProfile(e, "ProfileEdit")}
          className="save-btn"
          aria-describedby={labels.footer_label}
        >
          {labels.btn_save}
        </Button>
      </Form>
      <div className="notes">{labels.footer_label}</div>
    </div>
  );
};
